/* ============================================================
   Vittara Decor — Rodape v3 (26/08/2026)
   Melhoria progressiva sobre o footer padrao do tema.
   Sem este arquivo o rodape continua funcionando: as listas
   ficam abertas e nada quebra.
============================================================ */
(function () {
  'use strict';

  var MOBILE = '(max-width: 989px)';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---------- 1. faixa da marca ---------- */
  function brandBand(footer) {
    if (footer.querySelector('.vd-brandband')) return;
    var top = footer.querySelector('.footer__content-top');
    if (!top) return;

    var band = el('div', 'vd-brandband page-width');

    var left = el('div', 'vd-brand');
    var name = el('p', 'vd-brand-name');
    /* vittara 24/10: logo novo em imagem no lugar do nome em texto */
    var logo = document.createElement('img');
    logo.src = 'https://cdn.shopify.com/s/files/1/0957/4855/5115/files/vittara-logo-traco-cor-v2.png?v=1792957612&width=600';
    logo.alt = 'Vittara Decor';
    logo.width = 600; logo.height = 127;
    logo.loading = 'lazy';
    name.appendChild(logo);
    var tag = el('p', 'vd-brand-tag');
    tag.textContent = 'Casa, decoração e utilidades para o lar.';
    left.appendChild(name);
    left.appendChild(tag);

    var trust = el('ul', 'vd-trust');
    [
      ['truck', 'Frete grátis para todo o Brasil'],
      ['card', 'Até 3x sem juros'],
      ['chat', 'Atendimento por WhatsApp']
    ].forEach(function (item) {
      var li = document.createElement('li');
      var ico = el('span', 'vd-ico vd-ico--' + item[0]);
      ico.setAttribute('aria-hidden', 'true');
      var tx = document.createElement('span');
      tx.textContent = item[1];
      li.appendChild(ico);
      li.appendChild(tx);
      trust.appendChild(li);
    });

    band.appendChild(left);
    band.appendChild(trust);
    top.parentNode.insertBefore(band, top);
  }

  /* ---------- 2. acordeao nas listas de menu ---------- */
  function accordions(footer) {
    var blocks = footer.querySelectorAll('.footer-block--menu');
    var mq = window.matchMedia(MOBILE);

    Array.prototype.forEach.call(blocks, function (block, i) {
      var heading = block.querySelector('.footer-block__heading');
      var list = block.querySelector('.footer-block__details-content');
      if (!heading || !list || heading.querySelector('.vd-acc-toggle')) return;

      // lista longa vira duas colunas no desktop
      if (list.querySelectorAll('li').length > 6) block.classList.add('vd-two-col');

      var listId = list.id || 'vd-acc-panel-' + i;
      list.id = listId;

      var label = heading.textContent.trim();
      var btn = el('button', 'vd-acc-toggle');
      btn.type = 'button';
      btn.setAttribute('aria-controls', listId);

      var span = document.createElement('span');
      span.textContent = label;
      var chev = el('span', 'vd-chev');
      chev.setAttribute('aria-hidden', 'true');
      btn.appendChild(span);
      btn.appendChild(chev);

      heading.textContent = '';
      heading.appendChild(btn);

      function setOpen(open) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        block.classList.toggle('vd-collapsed', !open);
      }

      // no celular comeca fechado; no desktop sempre aberto
      setOpen(!mq.matches);

      btn.addEventListener('click', function () {
        setOpen(btn.getAttribute('aria-expanded') !== 'true');
      });

      var onChange = function (e) { setOpen(!e.matches); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    });
  }

  /* ---------- 3. newsletter vira cartao ---------- */
  function newsletterCard(footer) {
    var form = footer.querySelector('.footer__newsletter');
    if (!form) return;
    var block = form.closest('.footer-block');
    if (!block || block.querySelector('.vd-news-card')) return;

    var card = el('div', 'vd-news-card');
    while (block.firstChild) card.appendChild(block.firstChild);
    block.appendChild(card);
  }

  /* ---------- 4. barra inferior em uma linha ---------- */
  function bottomBar(footer) {
    var bottom = footer.querySelector('.footer__content-bottom');
    if (!bottom || bottom.querySelector('.vd-bottom')) return;

    var payment = bottom.querySelector('.footer__payment');
    var copyWrap = bottom.querySelector('.footer__copyright');
    if (!payment || !copyWrap) return;

    var row = el('div', 'vd-bottom page-width');
    copyWrap.parentNode.insertBefore(row, copyWrap);
    row.appendChild(copyWrap);
    row.appendChild(payment);
  }

  function init() {
    var footer = document.querySelector('.footer');
    if (!footer) return;
    try { brandBand(footer); } catch (e) {}
    try { accordions(footer); } catch (e) {}
    try { newsletterCard(footer); } catch (e) {}
    try { bottomBar(footer); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
